'use client'
import React from 'react'
import { Typography, MediaImageStandard } from 'components/Contentful'
import { Eyebrow } from 'components/Eyebrow'
import Section from 'components/Section'
import classNames from 'classnames'
import TrustMarkersSectionClientFdr from './TrustMarkersSectionClientFdr'

const VARIATION_TWO_COLUMNS = 'mobile_2_columns'

export default function TrustMarkersSectionClient({
  title,
  eyebrow,
  subtitle,
  styleSection,
  trustMarkersGrid,
  sectionBackgroundColor,
  subtitleVariant,
  subtitleMobileVariant,
  subtitleFontWeight,
  titleMarkerWeight,
  subtitleMarkerVariant,
  titleMarkerTextColor,
  config,
  variant,
}) {
  const dollarUSLocale = Intl.NumberFormat('en-US')
  const variation = config?.jsonContent?.variation
  const subtitleStyle = config?.jsonContent?.subtitleStyle

  if (variant === 'FdrVariant1') {
    return <TrustMarkersSectionClientFdr title={title} trustMarkersGrid={trustMarkersGrid} />
  }

  return (
    <Section
      backgroundColor={sectionBackgroundColor}
      data-testid="trust-markers-section"
      contain={false}
      className={''}
    >
      <div
        className={classNames(
          'trust-markers-content group flex flex-col items-center text-center',
          styleSection === 'black2'
            ? 'py-12  px-5 lg:py-12 lg:px-0 '
            : 'px-5 lg:px-12  py-12 lg:py-4 data-[marker-style="black1"]:py-0 data-[marker-style="black1"]:px-8 data-[marker-style="blue1"]:py-12 data-[marker-style="blue1"]:px-4 lg:data-[marker-style="blue1"]:py-16 lg:data-[marker-style="blue1"]:px-4 lg:data-[marker-style="black1"]:pt-8 lg:data-[marker-style="black1"]:px-0 lg:data-[marker-style="black1"]:pb-16 lg:data-[marker-style="blue2"]:pb-16',
          variation === VARIATION_TWO_COLUMNS && 'lg:pb-0! overflow-hidden'
        )}
        data-marker-style={styleSection}
        data-testid="trust-markers-content"
      >
        {eyebrow?.textContent?.json && (
          <Eyebrow
            content={eyebrow?.textContent}
            black={true}
            className={'mt-2 pb-0 displayXs'}
            variant="displayXS30"
          />
        )}
        {title?.textContent?.json && (
          <Eyebrow
            content={title?.textContent?.json}
            className={classNames(
              'trust-markers-title ',
              styleSection === 'black2'
                ? 'text-black text-[24px] lg:text-[32px] font-[Ultramarine] py-0! lg:py-6 leading-[1.3]! tracking-normal normal-case'
                : `${titleMarkerTextColor} py-6`
            )}
            variant={styleSection === 'black2' ? undefined : 'bodySm'}
            fontWeight="bold"
          />
        )}
        {subtitle?.textContent?.json && (
          <Typography
            className={`trust-markers-subtitle group-data-[marker-style="blue1"]:text-white ${
              subtitleStyle
                ? 'md:mt-[48px] md:mb-[24px] lg:mt-[32px] mt-0 mb-0 lg:mb-2 leading-[1.3] tracking-normal normal-case text-[24px] lg:text-[32px] font-bold'
                : ''
            }`}
            content={subtitle?.textContent?.json}
            variant={subtitleVariant}
            mobileVariant={subtitleMobileVariant}
            breakpoint="lg"
            responsive={true}
            fontWeight={subtitleFontWeight}
          />
        )}
        <div
          className={classNames(
            `trust-markers-markers  w-full ${
              variation === VARIATION_TWO_COLUMNS
                ? 'grid grid-cols-2 lg:flex lg:flex-row '
                : 'max-w-[425px] flex flex-col'
            } 
            lg:flex-row lg:w-auto lg:max-w-[initial]`,
            styleSection === 'blue3' && 'lg:pb-8 ',
            styleSection === 'black2' && 'mt-8 lg:mt-12',
            subtitleStyle && 'lg:w-full'
          )}
          data-testid="trust-markers-markers-container"
        >
          {trustMarkersGrid &&
            trustMarkersGrid?.gridItemsCollection?.items?.map((marker, index) => {
              let eyebrow, subtitle, image, imageTitle

              if (marker?.__typename === 'TrustMarker') {
                subtitle = {
                  nodeType: 'document',
                  data: {},
                  content: [
                    {
                      nodeType: 'paragraph',
                      data: {},
                      content: [
                        {
                          nodeType: 'text',
                          value: `${marker?.rating ?? 0} | ${
                            dollarUSLocale.format(marker?.totalReview) ?? 0
                          }+`,
                          marks: [
                            {
                              type: 'bold',
                            },
                          ],
                          data: {},
                        },
                        {
                          nodeType: 'text',
                          value: ' reviews',
                          marks: [],
                          data: {},
                        },
                      ],
                    },
                  ],
                }
                image = marker?.image
                imageTitle = marker?.image?.title
              } else {
                eyebrow = marker?.eyebrow
                subtitle = marker?.subtitle
                image = marker?.image
                imageTitle = marker?.image?.title
              }

              return (
                <div
                  className={classNames(
                    variation === VARIATION_TWO_COLUMNS
                      ? 'flex flex-col lg:mt-8 lg:pb-12'
                      : 'flex flex-col',
                    'trust-markers-item  items-center ',
                    'group-data-[marker-style="blue1"]:pb-8 group-data-[marker-style="blue1"]:border-b group-data-[marker-style="blue1"]:border-t-0 group-data-[marker-style="blue1"]:border-x-0 group-data-[marker-style="blue1"]:border-solid group-data-[marker-style="blue1"]:border-[#94bbfe]',
                    ` lg:py-0 lg:border-b-0  border-t-0 ${
                      variation === VARIATION_TWO_COLUMNS
                        ? 'lg:px-0'
                        : 'lg:border-r lg:border-y-0 lg:border-l-0 lg:border-solid lg:border-neutral-300 lg:last:border-r-0 lg:px-16'
                    }`,
                    'lg:group-data-[marker-style="blue1"]:border-b-0 lg:group-data-[marker-style="blue1"]:border-r lg:group-data-[marker-style="blue1"]:border-y-0 lg:group-data-[marker-style="blue1"]:border-l-0 lg:group-data-[marker-style="blue1"]:border-solid lg:group-data-[marker-style="blue1"]:border-[#94bbfe] lg:last:group-data-[marker-style="blue1"]:border-r-0',
                    'lg:group-data-[marker-style="black1"]:border-r lg:group-data-[marker-style="black1"]:border-[#c0cbd8] lg:group-data-[marker-style="black1"]:border-y-0 lg:last:group-data-[marker-style="black1"]:border-r-0',
                    styleSection !== 'black2' && 'mt-8 pb-12 flex-1 w-full',
                    styleSection === 'black2' &&
                      'lg:border-r border-[#c0cbd8] lg:border-y-0 lg:last:border-r-0 pb-[30px] mb-[30px] w-[108px] lg:w-auto mx-auto border-solid border-b-2 border-t-0 border-x-0 last:border-b-0 my-0 lg:mt-8 ',
                    'group-data-[marker-style="blue3"]:border-neutral-150 group-data-[marker-style="blue3"]:mt-6 lg:group-data-[marker-style="blue3"]:px-8 group-data-[marker-style="blue3"]:pb-6 lg:group-data-[marker-style="blue3"]:pb-0',
                    subtitleStyle &&
                      'border-[#c0cbd8] border-solid border-b-[1.5px] border-t-0 border-x-0 last:border-b-0'
                  )}
                  data-testid="trust-markers-item"
                  key={'marker-' + index}
                >
                  {eyebrow && (
                    <Eyebrow
                      className={'trust-markers-item-eyebrow pb-0'}
                      content={eyebrow}
                      variant="bodySm"
                      fontWeight="bold"
                      black
                    />
                  )}
                  {!image && (
                    <>
                      <Typography
                        content={marker?.title}
                        breakpoint="lg"
                        responsive={true}
                        fontWeight={titleMarkerWeight}
                        className={
                          'trust-markers-item-title text-[#3300ff] mt-4 group-data-[marker-style="black1"]:text-black group-data-[marker-style="black1"]:mt-0 group-data-[marker-style="blue1"]:text-white lg:group-data-[marker-style="blue1"]:mt-0 headingLg'
                        }
                        data-testid="trust-markers-item-title"
                      />
                      <Typography
                        content={marker?.subtitle}
                        variant={subtitleMarkerVariant}
                        mobileVariant={subtitleMarkerVariant}
                        breakpoint="lg"
                        responsive={true}
                        className={
                          'trust-markers-item-subtitle mt-[2px] lg:mt-4 md:text-[15px] md:font-normal md:leading-[26px] group-data-[marker-style="black1"]:mt-0 group-data-[marker-style="blue1"]:mt-0 group-data-[marker-style="blue1"]:text-white'
                        }
                        data-testid="trust-markers-item-subtitle"
                      />
                    </>
                  )}
                  {image && (
                    <div
                      className={`flex flex-col h-full justify-center items-center  ${
                        variation === VARIATION_TWO_COLUMNS
                          ? '[&>img]:object-contain lg:[&>img]:object-none lg:[&>img]:w-[220px]'
                          : '[&>img]:object-contain'
                      }
                      ${
                        styleSection === 'black2' ? '[&>img]:mb-1' : '[&>img]:mb-2'
                      }                      
                      `}
                    >
                      {styleSection === 'blue3' && (
                        <MediaImageStandard
                          content={image}
                          layout="fixed"
                          width={marker?.image?.width}
                          height={marker?.image?.height}
                          alt={imageTitle}
                        />
                      )}
                      {styleSection !== 'blue3' && (
                        <MediaImageStandard
                          content={image}
                          layout="fixed"
                          width={300}
                          height={62}
                          alt={imageTitle}
                          fetchPriority="high"
                          preload={true}
                        />
                      )}
                      <Typography
                        content={subtitle}
                        variant={subtitleMarkerVariant}
                        mobileVariant={subtitleMarkerVariant}
                        breakpoint="lg"
                        responsive={true}
                        className={classNames(
                          'trust-markers-item-subtitle group-data-[marker-style="black1"]:mt-0 group-data-[marker-style="blue1"]:mt-0 group-data-[marker-style="blue1"]:text-white group-data-[marker-style="blue3"]:hidden',
                          styleSection === 'black2' ? 'mt-0 ' : 'lg:mt-4'
                        )}
                      />
                    </div>
                  )}
                </div>
              )
            })}
        </div>
      </div>
    </Section>
  )
}
